<template>
  <BaseModal ref="BaseModal" @confirm="confirm" @close="close">
    <div class="select-base-amount-dialog">
      <el-tabs v-model="activeTab" type="card" style="width: 100%">
        <el-tab-pane
          v-for="v in tabs.filter(e => e.show)"
          :label="v.label"
          :name="v.value"
          :key="v.value"
        ></el-tab-pane>
      </el-tabs>
      <div class="table">
        <SimpleTable
          :showIndex="false"
          table-code="selectBaseAmountDialogOut"
          v-show="activeTab === 'out'"
          ref="tableOut"
          :columns="columnsOut"
          :data="tableDataOut"
        />
        <SimpleTable
          :showIndex="false"
          table-code="selectBaseAmountDialogIn"
          v-show="activeTab === 'in'"
          ref="tableIn"
          :columns="columnsIn"
          :data="tableDataIn"
        />
      </div>
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseModal/index.vue'
import SimpleTable from '@/components/SimpleTable/index.vue'

import {
  sortRecords,
  debounceAfter,
  aggregationAmount,
  aggregationSUM,
  dfsFn
} from '@/utils/index'

// 禁用特定行的复选框
function disableCondition(column, record, row) {
  return record.col < 5 && record.row > 4
}

const tableDataOut = [
  {
    tabName: '工程量清单',
    keyName: '调整后金额',
    total: false
  },
  // {
  //   tabName: '措施项目',
  //   keyName: '调整后金额',
  //   total: false
  // },
  {
    tabName: '人材机汇总',
    keyName: '金额',
    total: false
  },
  {
    tabName: '甲供材料',
    keyName: '金额',
    total: false
  }
]

export default {
  name: 'SelectBaseAmountDialog',
  components: { BaseModal, SimpleTable },
  props: {
    projectId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tabs: [
        { label: '表外项目', value: 'out', show: true },
        { label: '表内项目', value: 'in', show: true }
      ],
      activeTab: 'out',
      // 是否是费用
      isExpense: null,

      columnsOut: [
        { field: 'tabName', title: '页签名称' },
        {
          field: 'keyName',
          title: '字段名称'
        },
        {
          field: 'total',
          title: '合计',
          canEdit: true,
          canModify: true,
          cellType: 'checkbox',
          multiple: true
        }
      ],

      columnsIn: [
        { field: 'name', title: '费用名称' },
        {
          field: 'amount',
          title: '预算金额',
          canEdit: true,
          canModify: true,
          multiple: true,
          cellType: 'checkbox'
        }
      ],

      tableDataOut: [],

      tableDataIn: []
    }
  },
  computed: {},
  watch: {},

  created() {},
  mounted() {},
  methods: {
    // 显示弹窗
    show(options = {}) {
      this.options = options
      this.$refs.BaseModal.show({
        title: '取费基数',
        confirmText: '确定',
        width: '600px'
      })
      this.init()
    },

    init() {
      this.tableDataOut = JSON.parse(JSON.stringify(tableDataOut))

      this.tableDataIn = this.options.tableVm.tableData.map(e => ({
        name: e.projectName,
        id: e.id,
        amount: false
      }))
    },

    confirm(close) {
      let str = ''

      if (this.activeTab === 'out') {
        str = this.tableDataOut
          .filter(e => e.total)
          .map(e => e.tabName)
          .join('+')
      } else {
        str = this.tableDataIn
          .filter(e => e.amount)
          .map(e => `费用汇总(${e.name})`)
          .join('+')
      }
      this.$emit('confirm', this.options.selectedCellInfos, str)
      close()
    },

    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>
.select-base-amount-dialog {
  .table {
    height: 300px;
  }
}
</style>
